import moment, { urlFormat } from 'helpers/moment'
import { generateTypes, getType, getCollectionActionHandlers } from 'helpers/actions'
import update from 'immutability-helper'

const modelName = 'pricelist'
const modelPlural = 'pricelist'

export function get (date = 'today') {
  return {
    types: generateTypes(modelName),
    api: api => api(`${modelName}/${date}`),
    date
  }
}

export function copy (from, to = false) {
  return {
    types: generateTypes(`copy_${modelName}`),
    api: api => api(`${modelName}/copy/${from}${to && `/${to}` || ''}`, { method: 'put' }),
    from,
    to,
    onApiSuccess: (nextAction) => {
      nextAction.redirectTo = `/daily_products/${moment(to).format(urlFormat)}`
      nextAction.notify = { type: 'success', message: 'Updated the pricelist, you may need to refresh..' }

      return nextAction
    }
  }
}

export const actions = {
  get,
  copy
}

// WARNING / NOTE: There is no copy reducer for this state!

// Action Handlers
const initialState = []
function getTempId (model) {
  return `${model.product_id}:${moment(model.date).startOf('day').valueOf()}`
}
const ACTION_HANDLERS = Object.assign({},
  getCollectionActionHandlers({ modelName, modelPlural, getTempId }), // basically just for get() pricelist..
  getCollectionActionHandlers({ modelName: 'daily_product', getTempId }), // same as what the daily_products state gets

  // some overrides to daily_product collection; this actually modifies an existing pricelist item, but creates one..
  {
    [getType('create_daily_product', 'request')]: (state, action) => {
      let foundIndex = state.findIndex(model => getTempId(model) === getTempId(action.data))
      if (foundIndex < 0 || !state[foundIndex]) return state

      const merged = Object.assign({ __original_model: state[foundIndex] }, state[foundIndex], action.data)

      // update the foundIndex in the state with the sent action.data
      return update(
        state,
        { [foundIndex]: { $set: merged } }
      )
    },
    [getType('create_daily_product', 'success')]: (state, action) => {
      let foundIndex = state.findIndex(model => getTempId(model) === getTempId(action.data))
      if (foundIndex < 0 || !state[foundIndex]) return state

      // NOTE: Merge this, instead of just using payload, because it won't have product details, only daily_product
      const merged = Object.assign({}, state[foundIndex], action.payload)
      delete merged.__original_model

      return update(
        state,
        { [foundIndex]: { $set: merged } }
      )
    },
    [getType('create_daily_product', 'failure')]: (state, action) => {
      let foundIndex = state.findIndex(model => getTempId(model) === getTempId(action.data))
      if (foundIndex < 0 || !state[foundIndex]) return state

      // revert the foundIndex in the state with the original data (hopefully saved in the state previously)
      return update(
        state,
        { [foundIndex]: { $set: state[foundIndex].__original_model || state[foundIndex] } }
      )
    }
  }
)

export default function (state = initialState, action) {
  let handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/DailyProducts/modules/pricelist.js